import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { HeaderMain } from '../../headerMain';

import styles from './styles.module.scss';

export const LayoutMain: FC = () => {
  return (
    <div className={styles['layout']}>
      <div className={styles['container']}>
        <HeaderMain />
        <Outlet />
      </div>
    </div>
  );
};
